import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroTenant'), ...new Mutations('xeroTenants') };
